/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddHelperDto } from '../../models/add-helper-dto';
import { PosSession } from '../../models/pos-session';

export interface PosSessionsControllerAddHelper$Params {

/**
 * POS Session ID
 */
  id: string;
      body: AddHelperDto
}

export function posSessionsControllerAddHelper(http: HttpClient, rootUrl: string, params: PosSessionsControllerAddHelper$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSession>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerAddHelper.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSession>;
    })
  );
}

posSessionsControllerAddHelper.PATH = '/pos/sessions/{id}/helpers';
